export const SCOPES = {
  CREATOR: "creator",
}



// WEBPACK FOOTER //
// ./src/store/coach/dashboard/aimlabs-marketplace/aimlabs-marketplace.constants.js